import { INetworkState } from "../../interfaces/network.interface";
import { INetworkAction, actionTypes } from "../_actions/network.action";

const initialState: INetworkState = {
  chain: null,
  provider: null,
  whChainId: null,
  isConnected: false,
};

export const network = (state = initialState, action: INetworkAction): INetworkState => {
  switch (action.type) {
    case actionTypes.SET_CHAIN:
      return { ...state, chain: action.data };
    case actionTypes.SET_PROVIDER:
      return { ...state, provider: action.data };
    case actionTypes.SET_WH_CHAIN_ID:
      return { ...state, whChainId: action.data };
    case actionTypes.SET_EVM_CHAIN_ID:
      return { ...state, evmChainId: action.data };
    case actionTypes.SET_WHOLE_CONFIG:
      return {...state, ...action.data}
    case actionTypes.SET_IS_CONNECTED:
      return {...state, isConnected: action.data};
    default:
      return state;
  }
};

